import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-logout-v2',
  templateUrl: './logout-v2.component.html',
  styleUrls: ['./logout-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LogoutV2Component {}
